import { FocusMonitor } from '@angular/cdk/a11y';
import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { Component, ElementRef, Input, OnInit, Optional, Self } from '@angular/core';
import { ControlValueAccessor, UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, NgControl } from '@angular/forms';
import { MatLegacyFormFieldControl as MatFormFieldControl } from '@angular/material/legacy-form-field';
import { Subject } from 'rxjs';
import { AwardLevelParam } from '../../lottoloca-commom/lottery-modex';

@Component({
  selector: 'award-level-params',
  templateUrl: './award-level-params.component.html',
  styleUrls: ['./award-level-params.component.scss'],
  providers: [

    { provide: MatFormFieldControl, useExisting: AwardLevelParamsComponent },

  ],
  host: {
    '[class.floating]': 'shouldLabelFloat',
    '[id]': 'id',
    '[attr.aria-describedby]': 'describedBy',
  }
})
export class AwardLevelParamsComponent implements MatFormFieldControl<AwardLevelParam[]>, ControlValueAccessor, OnInit {

  static nextId = 0;
  parts: UntypedFormGroup;
  stateChanges = new Subject<void>();
  focused = false;
  //ngControl = null;
  errorState = false;
  controlType = 'award-level-params';
  id = `award-level-params-${AwardLevelParamsComponent.nextId++}`;
  describedBy = '';
  _isReady: boolean = false;

  private onChange: (value: AwardLevelParam[]) => void;
  _value: AwardLevelParam[];
  _items: UntypedFormArray;


  constructor(@Optional() @Self() public ngControl: NgControl,
    public fb: UntypedFormBuilder,
    private fm: FocusMonitor,
    private elRef: ElementRef<HTMLElement>) {

    // Setting the value accessor directly (instead of using
    // the providers) to avoid running into a circular import.
    if (this.ngControl != null) { this.ngControl.valueAccessor = this; }

    this.parts = fb.group({
      textValue: ''
    });

    fm.monitor(elRef.nativeElement, true).subscribe(origin => {
      this.focused = !!origin;
      this.stateChanges.next();
    });
  }


  writeValue(obj: AwardLevelParam[]): void {

    console.log("objxxxx  xxxxxx");
    console.log(obj);

    this.value = obj;
  }
  registerOnChange(onChange: (value: AwardLevelParam[]) => void): void {

    this.onChange = onChange;
  }



  registerOnTouched(fn: any): void {
    //throw new Error("Method not implemented.");
  }
  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;

    if (isDisabled) {
      this.parts.get("textValue").disable();
    }
    else {
      this.parts.get("textValue").enable();
    }
  }


  get empty() {
    const { value: { textValue } } = this.parts;

    return !textValue;
  }

  get shouldLabelFloat() { return this.focused || !this.empty; }

  @Input()
  get placeholder(): string { return this._placeholder; }
  set placeholder(value: string) {
    this._placeholder = value;
    this.stateChanges.next();
  }
  private _placeholder: string;

  @Input()
  get required(): boolean { return this._required; }
  set required(value: boolean) {
    this._required = coerceBooleanProperty(value);
    this.stateChanges.next();
  }
  private _required = false;

  @Input()
  get disabled(): boolean { return this._disabled; }
  set disabled(value: boolean) {
    this._disabled = coerceBooleanProperty(value);
    this.stateChanges.next();
  }
  private _disabled = false;

  @Input()
  get value(): AwardLevelParam[] | null {


    return this._value;

  }

  set value(value: AwardLevelParam[] | null) {

    console.log("value");
    console.log(value);


    if (value == null) {
      this._value = [];
    }
    else {

      this._value = value;
    }

    this.updateGui();

    this.stateChanges.next();
  }

  ngOnDestroy() {
    this.stateChanges.complete();
    this.fm.stopMonitoring(this.elRef.nativeElement);
  }

  setDescribedByIds(ids: string[]) {
    this.describedBy = ids.join(' ');
  }

  onContainerClick(event: MouseEvent) {
    // if ((event.target as Element).tagName.toLowerCase() != 'input') {
    //   this.elRef.nativeElement.querySelector('input')!.focus();
    // }
  }



  //******************************* */

  public _indexes: any[] = [];

  public updateGui(): any {

    if(this.value==null) return;


    let items: Array<UntypedFormGroup> = [];



    this.value.forEach(x => {

      items.push(this.createItem(x.description,x.numberAwards,x.jockerAwards,x.level))

    });

    console.log("items");
    console.log(items);

    this.orderForm = this.fb.group({
      items: this.fb.array(items)
    });

    this._items = this.orderForm.get("items") as UntypedFormArray;

    this._isReady = true;
    this.orderForm
      .valueChanges
      .subscribe(() => {

        this.propagateChanges();
      }
      );

  }

  public showValue() {

  }

  public onChangeCoordinate(X: number, Y: number, value: any) {


  }

  public addParameter() {


    this.addItem();


  }

  addItem(): void {

    this.items = this.orderForm.get('items') as UntypedFormArray;

    this.items.push(this.createItem('newDescription',[],[],0));

  }

  

  public propagateChanges() {
    
    let items = this.orderForm.get('items') as UntypedFormArray;

    this._value = items.value;

    if (this.onChange != null) {

       this.onChange(this.value)
    }
  }

  public showValues() {

  }


  createItem(description: string, numberAwards:number[],jockerAwards:number[],level:number): UntypedFormGroup {

 
    return this.fb.group({
      description: description,
      numberAwards:new UntypedFormControl(numberAwards),
      jockerAwards:new UntypedFormControl(jockerAwards),
   
      level:level
    });


  }

  orderForm: UntypedFormGroup;
  items: UntypedFormArray;


  ngOnInit() {
    this.updateGui();
  }

  public remove(index: number) {

    this._items = this.orderForm.get("items") as UntypedFormArray;

    this._items.removeAt(index);

  }
}
